import {useRoute} from '#imports';
import type {Location} from '@malt/nuxt-common-components-module/types';
import type {LocationItem} from '../../logged/features/search/search.types';

function parseCoordinate(value: unknown): number | undefined {
    if (typeof value !== 'string' || value === '') {
        return undefined;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}

export function useLocationFromRoute(): Location | LocationItem | null {
    const route = useRoute();

    if (!route.query.location) {
        return null;
    }

    const lat = parseCoordinate(route.query.lat);
    const lon = parseCoordinate(route.query.lon);
    const hasValidCoordinates = lat !== undefined && lon !== undefined;

    return {
        administrativeAreaLevel1: route.query.administrativeAreaLevel1 as string,
        administrativeAreaLevel1Code: route.query.administrativeAreaLevel1Code as string,
        administrativeAreaLevel2: route.query.administrativeAreaLevel2 as string,
        administrativeAreaLevel2Code: route.query.administrativeAreaLevel2Code as string,
        administrativeAreaLevel3: route.query.administrativeAreaLevel3 as string,
        administrativeAreaLevel3Code: route.query.administrativeAreaLevel3Code as string,
        administrativeAreaLevel4: route.query.administrativeAreaLevel4 as string,
        administrativeAreaLevel4Code: route.query.administrativeAreaLevel4Code as string,
        city: route.query.city as string,
        country: route.query.country as string,
        countryCode: route.query.countryCode as string,
        formattedAddress: route.query.location as string,
        ...(hasValidCoordinates ? {loc: {lat, lon}} : {}),
        region: route.query.region as string,
        street: route.query.street as string,
        street2: route.query.street2 as string,
        zipCode: route.query.zipCode as string,
        remoteAllowed: route.query.remoteAllowed === 'true',
    } as Location | LocationItem;
}
